module.exports = __webpack_public_path__ + "img/airplane_seat.1b51a79a.svg";